import React from 'react'
import {Link} from "gatsby";
import IconCheck from '../../Icons/Check'
import Button from '../../Button'

import * as S from './styles'

type Item = {
    title: string,
    active: boolean,
}

type DayUseBoxProps = {
    name: string
    color: string
    benefits: Item[]
}

const DayUseBox = ({ name, color, benefits }: DayUseBoxProps) => {
    return (
        <S.Box>
            <S.BoxTitle color={color}>{name}</S.BoxTitle>
            <S.BoxContent>
                {benefits.map((item, index) => (
                    <S.BoxList key={index} color={color} active={item.active}>
                        <IconCheck color={color} active={item.active} />
                        <span>{item.title}</span>
                    </S.BoxList>
                ))}
            </S.BoxContent>
        </S.Box>
    )
}

export default DayUseBox
